/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOrderForPickingQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrderForPickingQuery = {
  getOrderForPicking: {
    isInPool: boolean | null;
    orderSummary: { id: string; number: string | null } | null;
  };
};

export const GetOrderForPickingDocument = gql`
  query getOrderForPicking {
    getOrderForPicking {
      orderSummary {
        id
        number
      }
      isInPool
    }
  }
`;

/**
 * __useGetOrderForPickingQuery__
 *
 * To run a query within a React component, call `useGetOrderForPickingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderForPickingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderForPickingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderForPickingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOrderForPickingQuery, GetOrderForPickingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrderForPickingQuery, GetOrderForPickingQueryVariables>(
    GetOrderForPickingDocument,
    options,
  );
}
export function useGetOrderForPickingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrderForPickingQuery,
    GetOrderForPickingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrderForPickingQuery, GetOrderForPickingQueryVariables>(
    GetOrderForPickingDocument,
    options,
  );
}
// @ts-ignore
export function useGetOrderForPickingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrderForPickingQuery,
    GetOrderForPickingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetOrderForPickingQuery, GetOrderForPickingQueryVariables>;
export function useGetOrderForPickingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrderForPickingQuery, GetOrderForPickingQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetOrderForPickingQuery | undefined,
  GetOrderForPickingQueryVariables
>;
export function useGetOrderForPickingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrderForPickingQuery, GetOrderForPickingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrderForPickingQuery, GetOrderForPickingQueryVariables>(
    GetOrderForPickingDocument,
    options,
  );
}
export type GetOrderForPickingQueryHookResult = ReturnType<typeof useGetOrderForPickingQuery>;
export type GetOrderForPickingLazyQueryHookResult = ReturnType<
  typeof useGetOrderForPickingLazyQuery
>;
export type GetOrderForPickingSuspenseQueryHookResult = ReturnType<
  typeof useGetOrderForPickingSuspenseQuery
>;
export type GetOrderForPickingQueryResult = Apollo.QueryResult<
  GetOrderForPickingQuery,
  GetOrderForPickingQueryVariables
>;
